var $9867160d996455a0$exports = {};
$9867160d996455a0$exports = {
    "close": `Aizv\u{113}rt`,
    "notifications": `Pazi\u{146}ojumi`
};


export {$9867160d996455a0$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
